"use strict";
/* STATE */
Object.defineProperty(exports, "__esModule", { value: true });
let counter = 0, queue = new Set();
/* BATCH */
function batch(fn) {
    batch.start();
    const promise = fn();
    promise.then(batch.stop, batch.stop);
    return promise;
}
/* IS BATCHING */
batch.isActive = function () {
    return !!counter;
};
/* START */
batch.start = function () {
    counter++;
};
/* STOP */
batch.stop = function () {
    counter = Math.max(0, counter - 1);
    if (counter || !queue.size)
        return;
    const fns = [...queue];
    queue.clear();
    fns.forEach(fn => fn());
};
/* SCHEDULE */
batch.schedule = function (fn) {
    queue.add(fn);
};
/* EXPORT */
exports.default = batch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmF0Y2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYmF0Y2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFdBQVc7O0FBRVgsSUFBSSxPQUFPLEdBQUcsQ0FBQyxFQUNYLEtBQUssR0FBa0IsSUFBSSxHQUFHLEVBQUcsQ0FBQztBQUV0QyxXQUFXO0FBRVgsU0FBUyxLQUFLLENBQTJCLEVBQVc7SUFFbEQsS0FBSyxDQUFDLEtBQUssRUFBRyxDQUFDO0lBRWYsTUFBTSxPQUFPLEdBQUcsRUFBRSxFQUFHLENBQUM7SUFFdEIsT0FBTyxDQUFDLElBQUksQ0FBRyxLQUFLLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxJQUFJLENBQUUsQ0FBQztJQUV4QyxPQUFPLE9BQU8sQ0FBQztBQUVqQixDQUFDO0FBRUQsaUJBQWlCO0FBRWpCLEtBQUssQ0FBQyxRQUFRLEdBQUc7SUFFZixPQUFPLENBQUMsQ0FBQyxPQUFPLENBQUM7QUFFbkIsQ0FBQyxDQUFDO0FBRUYsV0FBVztBQUVYLEtBQUssQ0FBQyxLQUFLLEdBQUc7SUFFWixPQUFPLEVBQUUsQ0FBQztBQUVaLENBQUMsQ0FBQztBQUVGLFVBQVU7QUFFVixLQUFLLENBQUMsSUFBSSxHQUFHO0lBRVgsT0FBTyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUcsQ0FBQyxFQUFFLE9BQU8sR0FBRyxDQUFDLENBQUUsQ0FBQztJQUV0QyxJQUFLLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJO1FBQUcsT0FBTztJQUVyQyxNQUFNLEdBQUcsR0FBRyxDQUFDLEdBQUcsS0FBSyxDQUFDLENBQUM7SUFFdkIsS0FBSyxDQUFDLEtBQUssRUFBRyxDQUFDO0lBRWYsR0FBRyxDQUFDLE9BQU8sQ0FBRyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRyxDQUFFLENBQUM7QUFFOUIsQ0FBQyxDQUFDO0FBRUYsY0FBYztBQUVkLEtBQUssQ0FBQyxRQUFRLEdBQUcsVUFBVyxFQUFZO0lBRXRDLEtBQUssQ0FBQyxHQUFHLENBQUcsRUFBRSxDQUFFLENBQUM7QUFFbkIsQ0FBQyxDQUFDO0FBRUYsWUFBWTtBQUVaLGtCQUFlLEtBQUssQ0FBQyJ9